import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { crownQueryClient } from '@/common/api/crownQueryClient';
import { applicationFilters } from '@/common/schema/applicationFiltersSchema';
import { APPLICATIONS_PER_PAGE } from '@/components/ui/applications/constants';
import { listApplicationsInfiniteQuery } from '@/features/administrator-panel/applications/api/applicationsListApi';
import { ApplicationsIndex } from '@/features/administrator-panel/applications/ApplicationsIndex.tsx';

export const Route = createFileRoute('/admin/applications/')({
  validateSearch: applicationFilters,
  search: {
    middlewares: [stripSearchParams({type: [], tags: [], providers: []})]
  },
  loader: () =>
    crownQueryClient.ensureInfiniteQueryData(
      listApplicationsInfiniteQuery({
        limit: APPLICATIONS_PER_PAGE,
        filters: { search: '', status: ['PENDING_APPROVAL'] },
      }),
    ),
  component: ApplicationsIndex,
});
